export interface CanonicalGate {
  idx: number;
  lat: number;
  lon: number;
  alt_m: number;
  label?: string;
}

// Must stay in sync with parser/laps.py::MISSION_CIRCLE_ORDERS["Racing - Basics"].
export const CANONICAL_RACING_BASICS: CanonicalGate[] = [
  { idx: 1, lat: 50.34913120767158, lon: 16.638888988372205, alt_m: 383.59177445354464, label: "START / FINISH" },
  { idx: 2, lat: 50.350368976225255, lon: 16.63843598558113, alt_m: 394.471159446931 },
  { idx: 3, lat: 50.35205592462671, lon: 16.63953265780808, alt_m: 415.55768826928437 },
  { idx: 4, lat: 50.35223059164449, lon: 16.643127714329275, alt_m: 428.85920382990935 },
  { idx: 5, lat: 50.35136306745281, lon: 16.6463022694227, alt_m: 430.0744190481888 },
  { idx: 6, lat: 50.350151504854026, lon: 16.64402410885487, alt_m: 412.1603055653755 },
  { idx: 7, lat: 50.34923044442851, lon: 16.642589061961164, alt_m: 401.73869632762137 },
  { idx: 8, lat: 50.34795000768034, lon: 16.640573717544, alt_m: 380.96513891542855 },
];

export const CANONICAL_MATCH_TOLERANCE_M = 25;
// Fallback radius when the structure carries no usable size hint. The
// analysis pipeline (parser/laps.py) uses `max(4, size_m * 0.5)`; for the
// default 20m donut that yields a 10m capture, so 10m is the right
// fallback here too.
export const GATE_PASS_RADIUS_M = 10;
export const GATE_PASS_MIN_RADIUS_M = 4;
export const GATE_PASS_RADIUS_SCALE = 0.5;
// Minimum gap between two accepted passes of the same gate — matches
// ``parser/laps.CHECKPOINT_ENTRY_DEBOUNCE_SECONDS``.
export const GATE_PASS_DEBOUNCE_MS = 1000;
// Regex copy of ``parser/loader.STRUCTURE_SIZE_PATTERN`` — ``_20m`` → 20.
export const STRUCTURE_SIZE_PATTERN = /(\d+(?:\.\d+)?)m/i;
export const RACING_MISSION = "Racing - Basics";
